import * as yup from 'yup';
import { i18n } from '@localization';

var getAddNewUserSchema = function getAddNewUserSchema(phoneError, emailError) {
  return yup.object().shape({
    firstName: yup.string().required(''),
    lastName: yup.string().required(''),
    email: yup.string().email(i18n.t('forms.validation.email')).test('email', '', function (value, ctx) {
      if (emailError) {
        return ctx.createError({
          message: emailError
        });
      }

      return true;
    }),
    phoneNumber: yup.string().required('').min(2, '').test('phoneNumber', '', function (value, ctx) {
      if (phoneError) {
        return ctx.createError({
          message: phoneError
        });
      }

      return true;
    })
  });
};

export { getAddNewUserSchema };